import { DatabaseStoresIndexedByRecordingUuid, getRangeForAllRecordsWithRecordingUuid, UUID, NameOfIndexForRecordingUuidThenNumericIndex, DbRecording, ISODateTimeString, nowAsISODateTimeString } from "./DatabaseTypes";
import * as StateEvents from "../StateEvents";
import { DbEventsTableReader } from "./DbEventsTableReader";
import { DbEventsTableWriter } from "./DbEventsTableWriter";
import { DbRecordingsTableReader } from "./DbRecordingsTableReader";
import { ExtensionSettings } from "./DbExtensionSettings";
import { requireEvidenceDatabase } from "./getDatabase";

export class DbRecordingsTableWriter extends DbRecordingsTableReader {

	deleteRecording = async (recordingUuid: UUID) => {
		const recordingUuidRange = getRangeForAllRecordsWithRecordingUuid(recordingUuid);
		// Deletes from each store in parallel, with transactions that are scoped to each store to ensure they don't conflict
		await Promise.all(DatabaseStoresIndexedByRecordingUuid.map( storeName => async () => {
			const tx = this.db.transaction(storeName, "readwrite");
			for await (const cursor of tx.store.index(NameOfIndexForRecordingUuidThenNumericIndex).iterate(recordingUuidRange)) {
				await tx.store.delete(cursor.primaryKey);
			}
		}));
		// Once all the stores indexed by this recording are successfully deleted, delete the recording itself.
		await this.db.delete("recordings", recordingUuid);
		DbEventsTableReader.removeRecordingUuid(recordingUuid);
		DbEventsTableWriter.removeRecordingUuid(recordingUuid);		DbEventsTableReader.removeRecordingUuid(recordingUuid);
		this.deleteRecordingLocal(recordingUuid);
		StateEvents.RecordingDeleted.send({recordingUuid});
	};

	#addRecordingEntry = async (recording: DbRecording) => {
		await this.db.add("recordings", recording);
		StateEvents.RecordingCreated.send(recording);
		this.addOrUpdatedRecordingLocal(recording);
	};

	createRecording = async (args: Omit<DbRecording, "recordingUuid" | "startTimeIso">) => {
		const startTimeIso = nowAsISODateTimeString();
		const newEntry: DbRecording = {
			recordingUuid: crypto.randomUUID(),
			startTimeIso,
			...args,
			globalSearchTermsNewlineSeparated: (await ExtensionSettings.get()).sharedSearchTermField,
		};
		await this.#addRecordingEntry(newEntry);
		return newEntry;
	};


	static override async create() {
		const db = await requireEvidenceDatabase();
		const recordings = await db.getAll("recordings") ?? [];
		return new DbRecordingsTableWriter(db, recordings);
	}

	static #instancePromise: Promise<DbRecordingsTableWriter> | undefined;
	static override get instancePromise() {
		return DbRecordingsTableWriter.#instancePromise ??= DbRecordingsTableWriter.create();
	}


}
